import apiClient from "../common/apiClient";

export default class UserController {
  async Create(data, token) {
    try {
      //debugger
      return await apiClient.post("/user/", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(data, token) {
    try {
      return await apiClient.put("/user/", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Get(tenantId, token) {
    try {
      return await apiClient.get("/user/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async getServicesMapped(tenantId, token) {
    try {
      return await apiClient.get("/subscription/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async getAllUsers(token, tenantId) {
    try {
      // //debugger
      return await apiClient.get("/user/alluser/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async Delete(id, token) {
    try {
      return await apiClient.delete("/user/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetRoles(token, tenantId) {
    try {
      return await apiClient.get("/user/getrolesdd/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
